import { SET_PARSE_CONFIGS } from '../actions/types';

const INITIAL_STATE = {
  selectedPartners: {},
  monitoredTicketIdFirstChar: [],
  copiedTextSourceOptions: {},
  partnerProtectorRatingToolConfig: {},
  specialistRatingToolConfig: {},
  enableChatQuickReplies: false,
  debounceAmountForGetPredictionText: null,
};

const parseConfig = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_PARSE_CONFIGS:
      return { ...state, ...action.configs };
    default:
      return state;
  }
};

export default parseConfig;
